import { Link } from "react-router-dom";

function CurrentArticle(props) {

    const AuthorList = ({ authors }) => {
        
    
        return <div>{props.article_type.toUpperCase()}&nbsp;&nbsp;|&nbsp;&nbsp;<span className="current_authors">BY {authors?.toUpperCase()}</span></div>;
    };

    return (
      <>
        <div className="curra_block">
            <h3 className='curra_subtitle'>
                <AuthorList authors={props.authors} />
            </h3>
            
            <p className="curra_title"><Link className='curra_title_link' to={`/article/${props.id}/${props.title.toLowerCase().replace(/\s+/g, '-')}`}>{props.title.toUpperCase()}</Link></p>

            <div className='onea_hr'>

            </div>
        </div>
      </>
    );
}

export default CurrentArticle;
